import { render, staticRenderFns } from "./entry-card.vue?vue&type=template&id=4828e83b&scoped=true&"
import script from "./entry-card.vue?vue&type=script&lang=js&"
export * from "./entry-card.vue?vue&type=script&lang=js&"
import style0 from "./entry-card.vue?vue&type=style&index=0&id=4828e83b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828e83b",
  null
  
)

export default component.exports